import React from 'react'
import { useForm } from "react-hook-form";
import { TextField, Button, Stack, MenuItem } from "@mui/material";

const ManagerForm = () => {
    const { register, handleSubmit, watch, formState: { errors }, handleChange, control } = useForm();

    const onSubmit = (data) => {
        console.log(data);
    }
  return (
    <>
            <div>


                <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete='off' >
                    <Stack spacing={2}>
                        <h1>Manager Form</h1>

                        <TextField name="manager_id" label='Manager id' {...register("manager_id")} />
                        <TextField name="manager_name" label='Manager name' {...register("manager_name")} />

                        <label>Date of birth:</label>
                        <input type="date" id='date_of_birth' {...register('date_of_birth', { valueAsDate: true })} />
                        
                        <label>Date of death:</label>
                        <input type="date" id='date_of_death' {...register('date_of_death', { valueAsDate: true })} />

                       


                        <Button type='submit' variant="outlined">Submit</Button>

                    </Stack>

                </form>


            </div>
        </>
  )
}

export default ManagerForm